module.exports = __webpack_public_path__ + "static/media/cash.0314e9a7.png";